export default __webpack_public_path__ + "static/media/BLT.9824c718.jpg";